
let el = document.createElement('x-test');

let supportsBackgroundClipText = typeof el.style.BackgroundClip !== 'undefined' && (el.style.BackgroundClip = 'text', el.style.BackgroundClip === 'text');

let supportsWebkitBackgroundClipText = typeof el.style.webkitBackgroundClip !== 'undefined' && (el.style.webkitBackgroundClip = 'text', el.style.webkitBackgroundClip === 'text');

if(!supportsBackgroundClipText && !supportsWebkitBackgroundClipText) {
	$('body').addClass('no-background-clip-text');
}

// window.location.origin fix for IE

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}
